import React from 'react'
import {AgGridReactProps, AgGridReact} from 'ag-grid-react'
import {AllCommunityModule, GridReadyEvent, provideGlobalGridOptions, ModuleRegistry} from 'ag-grid-community'
import {debounce} from 'lodash'
import './checkboxStyles.css'
import {getHeighOfNavActionBar} from '@oc/utils'

ModuleRegistry.registerModules([AllCommunityModule])
provideGlobalGridOptions({
    theme: 'legacy'
})

interface BorderStyle {
    borderWidth: number
    borderColor: string
    borderStyle: string
}

/**
 * @deprecated Use OcAgGrid instead.
 */
export function AgGrid(props: AgGridReactProps & {resizable?: boolean; border?: BorderStyle}) {
    const {rowData, onGridReady, resizable, border, ...restProps} = props

    const ready = React.useCallback(
        (event: GridReadyEvent) => {
            if (onGridReady) {
                onGridReady(event)
            }
        },
        [onGridReady]
    )

    const agGridWrapperRef = React.useRef<HTMLDivElement>(null)

    const defaultHeight = props.gridOptions?.paginationAutoPageSize ? 250 : 500
    const [agWrapperHeight, setAgWrapperHeight] = React.useState(defaultHeight)

    React.useEffect(() => {
        let mounted = true
        const resizeAgGrid = debounce(() => {
            if (resizable && mounted) {
                let wrapperTop = 0
                if (agGridWrapperRef.current) {
                    wrapperTop = agGridWrapperRef.current.getBoundingClientRect().top
                }

                const countedHeight = window.innerHeight - wrapperTop - getHeighOfNavActionBar()
                setAgWrapperHeight(countedHeight > 300 ? countedHeight : 300)
            } else {
                setAgWrapperHeight(defaultHeight)
            }
        }, 10)

        resizeAgGrid()
        window.addEventListener('resize', resizeAgGrid, {passive: true})

        return () => {
            mounted = false
            window.removeEventListener('resize', resizeAgGrid)
        }
    }, [agGridWrapperRef, resizable, defaultHeight])

    let borderStyle = {}
    if (border) {
        borderStyle = {...border, borderWidth: border.borderWidth}
    }
    return (
        <div
            className="ag-theme-material"
            ref={agGridWrapperRef}
            style={{height: agWrapperHeight, width: '100%', ...borderStyle}}
        >
            <AgGridReact onGridReady={ready} rowData={rowData} {...restProps} tooltipShowDelay={0} />
        </div>
    )
}
